(() => {
  const supported = document.currentScript?.dataset.tb25StockDefault === 'true';
  document.documentElement.dataset.tb25StockDefault = supported ? 'supported' : 'unsupported';
  if (!supported) return;
  const normalize = () => {
    const url = new URL(location.href);
    if (url.searchParams.has('filter.v.availability')) return;
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.delete('page');
    location.replace(url.href);
  };
  if (document.documentElement.dataset.tb25RedirectPending !== 'true') normalize();
  window.addEventListener('pageshow', normalize);
  window.addEventListener('popstate', normalize);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^\/collections\/[^/]+\/?$/.test(url.pathname) || url.hash && url.pathname === location.pathname) return;
    if (!url.searchParams.has('filter.v.availability')) url.searchParams.set('filter.v.availability', '1');
    link.href = url.href;
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    const url = new URL(form.action, location.href);
    if (url.origin !== location.origin || !/^\/collections\/[^/]+\/?$/.test(url.pathname)) return;
    if (new FormData(form).has('filter.v.availability')) return;
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = 'filter.v.availability'; input.value = '1'; input.dataset.tb25Default = 'true';
    form.append(input);
  });
})();
